import Parse from 'parse'
import {ParseDbService, cdLinkCategorySchema as Schema} from "./parse.db.service";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.CdLinkCategoryClassName);
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.name, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    name: item.get(Schema.name)
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let ClassItem = Parse.Object.extend(ParseDbService.CdLinkCategoryClassName, null, null);
    let classObj = new ClassItem();
    classObj.set(Schema.name, item.name.toLowerCase());
    return classObj.save();
}

function edit(item) {
    let classObj = item.parseItem;
    classObj.set(Schema.name, item.name.toLowerCase());
    return classObj.save();
}

export const CdLinkCategoryService = {
    getAll,
    add,
    edit
};

